import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import _objectWithoutProperties from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/createSuper";
import _applyDecoratedDescriptor from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _dec2, _class;

import Protocol from './protocol';
import { invoke } from './lib/tenvideo';
import env from './lib/env';
import { parse } from './util/cookie';
import { compareVersion, assign } from './util/index';
import { version, retry, UnsupportedVersionError } from './util/decorators'; // 网络状态

var NETWORK_STATE = ['offline', 'wifi', '2g', '3g', '4g', 'other'];
var PROTOCOL = !location.protocol.match(/^https?:/) ? 'https://' : location.protocol;
var matchVersion = navigator.userAgent.match(/QQLive(HD|Kid)?(Browser|_MAC)?[\s/]*(\d+(\.\d+)*)/);
var APP_VERSION = matchVersion && matchVersion[3] ? matchVersion[3].slice(0, 5) : '';
/**
 * 图片上传
 * @param base64
 * @private
 */

function _uploadImage(base64) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: 'https://node.video.qq.com/x/services/imageupload',
      type: 'POST',
      data: {
        base64: base64
      },
      xhrFields: {
        withCredentials: true
      },
      success: function success(json) {
        if (json && json.ret === 0 && json.result && json.result.access && json.result.access.length > 0) {
          resolve(json.result.access[0]);
        } else {
          reject();
        }
      },
      error: function error(e) {
        reject(e);
      }
    });
  });
}
/**
 * Phone 端 JSBridge
 * @class PhoneJSBridge
 * @extends {Protocol}
 */


var PhoneJSBridge = (_dec = retry(3, 500), _dec2 = version('6.1.9'), (_class = /*#__PURE__*/function (_Protocol) {
  _inherits(PhoneJSBridge, _Protocol);

  var _super = _createSuper(PhoneJSBridge);

  function PhoneJSBridge() {
    _classCallCheck(this, PhoneJSBridge);

    return _super.apply(this, arguments);
  }

  _createClass(PhoneJSBridge, [{
    key: "logout",
    value: function logout() {
      var _this = this;

      return this.checkApi(['logout']).then(function (api) {
        if (api.logout) {
          return invoke('logout', {
            'needBack': false
          });
        } else {
          return _this.openLogin();
        }
      });
    }
    /**
     * 获取指定账号类型用户信息
     * @param {Array} type - 类型数组
     */

  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (type.indexOf('qq') < 0 && type.indexOf('wx') < 0) {
        // 不支持其他账号类型
        return Promise.reject(null);
      }

      return invoke('getUserInfo', {
        type: type
      }).then(function (userInfo) {
        if (userInfo) {
          var _userInfo = {};

          for (var _type in userInfo) {
            var headurl = userInfo[_type].headImgUrl ? userInfo[_type].headImgUrl.replace(/^https:?/, '') : '';
            _userInfo[_type] = {
              headurl: headurl,
              nick: userInfo[_type].nickname,
              type: _type,
              id: _type === 'wx' ? userInfo[_type].openId : userInfo[_type].uin
            };
          }

          return _userInfo;
        }

        return null;
      });
    }
    /**
     * 获取指定类型用户 cookie
     * @param {Array} type - 类型数组
     */

  }, {
    key: "getCookie",
    value: function getCookie() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (type.indexOf('qq') < 0 && type.indexOf('wx') < 0) {
        // 不支持其他账号类型
        return Promise.reject(null);
      }

      return invoke('getCookie', {
        type: type
      }).then(function (res) {
        if (!res) return null;
        var cookies = {};

        for (var key in res) {
          cookies[key] = parse(res[key]);
          cookies[key].main_login = key;
        }

        return cookies;
      });
    }
    /**
     * 获取登录用户的账号类型
     * @returns {String} loginType(qq or wx)
     */

  }, {
    key: "getMainLoginType",
    value: function getMainLoginType() {
      return invoke('getMainLoginType');
    }
    /**
     * 返回上一级
     * @returns {Promise}
     */

  }, {
    key: "goBack",
    value: function goBack() {
      return invoke('goBack');
    }
    /**
     * 单片支付
     * @returns {Promise} A promise resolve an Object.
     * @property {Number} result.invoked - 是否调用成功，1/0
     * @property {Number} result.paySucc - 是否购买成功，1/0
     */

  }, {
    key: "openPaySingle",
    value: function openPaySingle() {
      return invoke('openPaySingle');
    }
    /**
     * 切换登录
     *
     * @param {String} type - 账号类型
     * @returns {Promise}
     */

  }, {
    key: "switchLogin",
    value: function switchLogin(type) {
      return invoke('switchLoginState', {
        userType: type
      });
    }
    /**
     * 显示站内信入口:
     * @param {Number} options.unreadNum - 未读信息数
     * @param {Number} options.url       - 站内信详情页
     * @param {Number} options.show      - 是否显示。当隐藏时，不用传前两个参数
     */

  }, {
    key: "showMessageButton",
    value: function showMessageButton() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        unreadNum: 0,
        url: '',
        show: false
      };
      return invoke('showMessageButton', options);
    }
    /**
     * 拉起分享窗口面板，支持微信好友、朋友圈、QQ、空间等
     * @returns {Promise}
     */

  }, {
    key: "openToolsDialog",
    value: function openToolsDialog() {
      return invoke('openToolsDialog');
    }
    /**
     * 设置分享的相关内容
     * @param {Object} options - 分享相关配置
     * @returns {Promise}
     */

  }, {
    key: "setMoreInfo",
    value: function setMoreInfo() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return invoke('setMoreInfo', _objectSpread({
        'hasRefresh': true,
        'hasShare': true,
        'hasFollow': true
      }, options));
    }
    /**
     * 获取用户位置信息
     * @returns {Promise} A promise resolve an Object.
     * @property {String} [result.poiName] - 地区名字，如：深圳市南山区
     * @property {String} [result.lon] - 经纬度
     * @property {String} [result.lat] - 经纬度
     * @property {String} [result.address] - 详细地址
     */

  }, {
    key: "getLocation",
    value: function getLocation() {
      return invoke('getLocation');
    }
    /**
     * 获取网络状态
     * @returns {String} "offline", "wifi", "2g", "3g", "4g", "other"
     */

  }, {
    key: "getNetworkState",
    value: function getNetworkState() {
      return invoke('getNetworkState').then(function (_ref) {
        var _ref$state = _ref.state,
            state = _ref$state === void 0 ? 0 : _ref$state;
        return NETWORK_STATE[state] || 'offline';
      });
    }
    /**
     * 禁止页面上拉顶部和下拉底部的反弹效果
     * @param {Boolean} disable - 是或不禁止反弹效果
     * @returns {Promise} null
     */

  }, {
    key: "disablePageBounces",
    value: function disablePageBounces() {
      var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return invoke('disablePageBounces', {
        disable: disabled
      });
    }
    /**
     * 通过图片地址进行外部分享
     * @param {String} imageUrl - 图片地址
     * @author wingwan
     * @returns {Promise}
     */

  }, {
    key: "shareImageByUrl",
    value: function shareImageByUrl() {
      var imageUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return invoke('shareLocalImage', {
        imageUrl: imageUrl
      });
    }
    /**
     * 检测 APP 分享本地图片 API 的可用性
     * @returns {Promise}
     */

  }, {
    key: "_checkShareLocalImageAPI",
    value: function _checkShareLocalImageAPI() {
      if (compareVersion(APP_VERSION, '6.0.0') < 0) {
        return false;
      } else {
        if (env.isIos) return true; // hack 安卓 6.2.1-6.2.2 版本分享bug

        if (compareVersion(APP_VERSION, '6.2.1') > 0 && compareVersion(APP_VERSION, '6.2.5') < 0) {
          return false;
        }

        return true;
      }
    }
    /**
     * 分享本地图片，低版本（6.0.0 以下）及安卓 6.2.1-6.2.2 版本不支持的情况下会先走 node 上传，再通过 url 地址分享
     * @param {String} base64Str - 图片转换后的 base64 地址
     * @author wingwan
     * @version 6.0.0
     * @returns {Promise} url
     */

  }, {
    key: "shareLocalImage",
    value: function shareLocalImage() {
      var _this2 = this;

      var base64Str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.checkApi(['shareLocalImage']).then(function (res) {
        if (res.shareLocalImage && _this2._checkShareLocalImageAPI()) {
          return invoke('shareLocalImage', {
            // 客户端要求去掉toDataUrl默认生成的base64头，传纯base64字符串即可
            'imgbase64String': base64Str.replace(/^data:image\/(png|jpeg|webp);base64,/, '')
          });
        } else {
          _this2.showLoading();

          return _uploadImage(base64Str).then(function (url) {
            var picUrl = PROTOCOL + '//' + url; // iOS代码实现有问题，要先调一下saveImage,不论是否成功，收到回调后再调分享图片

            if (env.isIos) {
              return _this2.saveImage(picUrl).then(function () {
                _this2.hideLoading();

                return _this2.shareImageByUrl(picUrl);
              });
            } else {
              _this2.hideLoading();

              return _this2.shareImageByUrl(picUrl);
            }
          });
        }
      }).catch(function (e) {
        _this2.hideLoading();

        _this2.toast('分享失败！');

        console.error(e);
      });
    }
    /**
     * 保存图片到本地
     * @param {String} picUrl - 在线图片地址
     * @author wingwan
     * @returns {Promise}
     */

  }, {
    key: "saveImage",
    value: function saveImage(picUrl) {
      return invoke('saveImage', {
        'url': picUrl
      });
    }
    /**
     * 下载App
     * @param {String} options - 在线图片地址
     * @author colynchen
     * @returns {Promise}
     */

  }, {
    key: "download3rdApp",
    value: function download3rdApp() {
      var _this3 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Promise(function (resolve, reject) {
        invoke('download3rdApp', options).then(function () {
          if (env.isIos) {
            setTimeout(function () {
              resolve();
            }, 2000);
            return;
          }

          var progress = 0;
          var startTime = new Date().getTime();
          var timer = setInterval(function () {
            invoke('checkDowload3rdAppState', {
              'downloadUrl': options.downloadUrl,
              'packageName': options.packageName
            }).then(function (res) {
              if (res.progress >= 100) {
                // 完成下载
                _this3.hideLoading();

                resolve();
                clearInterval(timer);
              } else if (progress > res.progress) {
                // 可能下载中断
                clearInterval(timer);
                var now = new Date().getTime();

                if (now - startTime > 3000) {
                  // 出现1分钟无响应，则提示网络中断
                  _this3.hideLoading();

                  _this3.toast('可能网络异常或者中断下载，请稍后重试！');

                  reject({
                    msg: '可能网络异常或者中断下载，请稍后重试！',
                    code: 504
                  });
                }
              } else {
                progress = res.progress;

                _this3.showLoading('下载中' + (res.progress > 0 ? '(' + Math.floor(res.progress) + '%)' : ''));
              }
            }).catch(function (e) {
              _this3.hideLoading();

              _this3.toast(e.msg || '网络异常，请稍后重试！');

              reject({
                msg: e.msg || '网络异常，请稍后重试！',
                code: e.code || 504
              });
            });
          }, 60);
        });
      });
    }
  }, {
    key: "checkDiscount",
    value: function checkDiscount() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_get2 = _get(_getPrototypeOf(PhoneJSBridge.prototype), "checkDiscount", this)).call.apply(_get2, [this].concat(args));
    }
    /**
     * 拉起IAP支付
     * @param options {Object} - Pay options
     * @param options.id {Number} - 商品 id，支付的关键参数
     * @param options.amount {Number} - 购买数量
     * @param options.groupid {String} - 折扣id
     * @param [options.vipType='vip'] {String} - 会员类型
     * @param [options.offerid] {Number} - 商品offerid，vipType为svip或其它时为必填字段
     * @param [options.aid] {String} - 根据特定规则拼接的 aid 字符串，用于平台、版本号等
     * @param [options.ap] {Number} - 自动续费，只有H5支付时才会拼接
     * @param [options.price] {Number} - 商品价格
     * @param [options.product_type] {Number} - 商品类型：month 包月, day 按天开通, serial 连续订阅
     * @param [options.serialpay] {Number} - 是否连续订阅：1, 0
     * @param [options.ru] {String} - 开通成功后跳转链接
     * @returns {Promise} A Promise that returns an Object if resolved
     * @example <caption>Pass product options to client pay.</caption>
     * atom.openPay({
     *     "aid": "V0$$2:5$4:3$1:0$11:3$3:5.4.0.2017$8:4",
     *     "ap": 0,
     *     "id": "com.tenvideoios.OneMonthPay1",
     *     "amount": "1",
     *     "price": "25",
     *     "product_type": "month"
     * })
     */

  }, {
    key: "openPay",
    value: function openPay() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _options$vipType = options.vipType,
          vipType = _options$vipType === void 0 ? 'vip' : _options$vipType,
          id = options.id,
          price = options.price,
          groupid = options.groupid,
          params = _objectWithoutProperties(options, ["vipType", "id", "price", "groupid"]);

      if (!id) {
        throw {
          errCode: -10,
          errMsg: "[atom.openPay]miss required option(options.id)"
        };
      }

      assign(params, {
        product_price: price,
        productprice: price,
        id: id,
        productid: id,
        monthgroup: groupid ? encodeURIComponent("group_id=".concat(groupid)) : ''
      });

      switch (vipType) {
        case 'vip':
          return this._openPay(params);

        case 'svip':
          return this._openSVIPPay(params);

        default:
          return this._openCommonPay(params);
      }
    }
  }, {
    key: "_openPay",
    value: function _openPay(options) {
      var _this4 = this;

      var product_type = options.product_type,
          amount = options.amount,
          params = _objectWithoutProperties(options, ["product_type", "amount"]);

      if (product_type === 'day') {
        assign(params, {
          product_type: product_type,
          day: amount
        });
      } else {
        assign(params, {
          product_type: 'month',
          month: amount
        });
      }

      if (product_type === 'serial') {
        params.serialpay = 1;
      }

      var apiName = product_type === 'day' ? 'openPayByDay' : 'openPay';

      if (this.getVersion().compare('6.4.1')) {
        return invoke(apiName, params);
      }

      return new Promise(function (resolve, reject) {
        _this4.once('onIAPPaySuccess', function () {
          resolve({
            paySucc: 1
          });
        });

        invoke(apiName, params).then(resolve).catch(reject);
      });
    }
  }, {
    key: "_openSVIPPay",
    value: function _openSVIPPay(options) {
      if (!options.offerid) {
        throw {
          errCode: -10,
          errMsg: "[atom._openSVIPPay]miss required option(options.offerid)"
        };
      }

      var amount = options.amount,
          product_type = options.product_type,
          params = _objectWithoutProperties(options, ["amount", "product_type"]);

      assign(params, {
        month: amount,
        payingitem: amount,
        ap: 0
      });

      if (product_type === 'serial') {
        params.serialpay = 1;
      }

      return invoke('purchaseSVIP', params);
    }
  }, {
    key: "_openCommonPay",
    value: function _openCommonPay(options) {
      if (!options.offerid) {
        throw {
          errCode: -10,
          errMsg: "[atom._openCommonPay]miss required option(options.offerid)"
        };
      }

      var amount = options.amount,
          product_type = options.product_type,
          params = _objectWithoutProperties(options, ["amount", "product_type"]);

      assign(params, {
        month: amount,
        payingitem: amount,
        ap: 0,
        viptype: 100
      });

      if (product_type === 'serial') {
        params.serialpay = 1;
      }

      return this.checkApi(['commonOpenPay']).then(function (api) {
        // 判断版本兼容性
        if (!api.commonOpenPay) {
          throw new UnsupportedVersionError('commonOpenPay is unsupported for this version');
        }

        return invoke('commonOpenPay', params);
      });
    }
  }]);

  return PhoneJSBridge;
}(Protocol), (_applyDecoratedDescriptor(_class.prototype, "getLocation", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "getLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkDiscount", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "checkDiscount"), _class.prototype)), _class));
export default new PhoneJSBridge();